import { BackButton, NewListViewProduct } from "@core/components";
import { IonIcon, IonSkeletonText } from "@ionic/react";
import classNames from "classnames";
import { heart, search } from "ionicons/icons";
import React from "react";
import { useHistory } from "react-router";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { useIsViewFocused } from "../../../hooks";
import { useGetIncludeProductsQuery } from "../../../providers/products";
import { useActiveOrMainShippingZone } from "../../../providers/shippingZones";
import { useWishListData } from "../../../providers/wishListStore";
import Page from "../../page-layout";
import styles from "./Wishlist.module.scss";
import { useTranslation } from "react-i18next";
import PullToRefresh from "../../../parhato2/src/entities/pullToRefresh";
import { useGetWishlistQuery } from "../../../providers/wishlist";

const cx = classNames.bind(styles);
const SearchButton = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleGoToSearchPage = () => {
    history.push("/search-main-categories");
  };

  return (
    <div
      onClick={handleGoToSearchPage}
      className={cx("w-[8.5rem] h-14 fixed bottom-[1.375rem] left-[1.5rem] rounded-3xl z-[999999999] bg-gray-500")}
    >
      <div className="w-full h-full flex flex-col justify-center items-center py-[0.875rem] px-[1.5rem]">
        <div className="flex items-center justify-center gap-1">
          <IonIcon icon={search} className="text-[1rem] text-white" />
          <div className="font-bold text-sm text-white mr-1">{t("Search")}</div>
        </div>
      </div>
    </div>
  );
};

const Wishlist: React.FC = () => {
  const { wishListProducts: wishListProductsIdsFromStore } = useWishListData();
  const history = useHistory();
  const { t } = useTranslation();

  const isViewFocused = useIsViewFocused();

  const { activeShippingZone } = useActiveOrMainShippingZone();

  const wishlistProductsEnabled = !!wishListProductsIdsFromStore.length && isViewFocused;
  const { data: wishlistProductsIds, isLoading: isWishlistProductsIdsLoading } = useGetWishlistQuery({
    options: {
      enabled: wishlistProductsEnabled,
    },
  });
  const isWishlistLoading = wishlistProductsEnabled && isWishlistProductsIdsLoading;

  const getIncludeProductsEnabled = wishlistProductsEnabled && !isWishlistProductsIdsLoading;
  const { data: wishlistProducts, isLoading: isGetIncludeProductsLoading } = useGetIncludeProductsQuery({
    include: wishlistProductsIds?.productIds || wishListProductsIdsFromStore || [],
    params: {
      zoneId: activeShippingZone.id,
    },
    options: {
      enabled: getIncludeProductsEnabled,
    },
  });
  const isProductsLoading = wishlistProductsEnabled && isGetIncludeProductsLoading;

  const handleGoToSearchPage = () => {
    history.push("/search-main-categories");
  };

  const isLoading = isWishlistLoading || isProductsLoading;

  return (
    <Page className="flex flex-col gap-2">
      <Page.Header className="flex items-center justify-start h-16 mt-[env(safe-area-inset-top)]">
        <MaxWidthContainer classList="flex items-center justify-center bg-white  ">
          <div className="flex justify-center items-center w-full relative">
            <div className=" absolute left-2.5">
              <BackButton />
            </div>
            <div className="flex-1 text-center font-bold text-[1.125rem]">{t("Favorites")}</div>
          </div>
        </MaxWidthContainer>
      </Page.Header>
      <Page.Content>
        <PullToRefresh />
        <MaxWidthContainer classList="flex flex-col justify-center items-center pb-24">
          {isLoading ? (
            <div className="flex flex-col gap-2">
              <div className="grid grid-cols-2 justify-center gap-y-2.5 gap-x-2.5">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={i} className="flex flex-col border rounded-lg p-2 gap-2">
                    <IonSkeletonText animated className="h-28 w-full rounded-lg" />
                    <IonSkeletonText animated className="h-4 w-3/4" />
                    <IonSkeletonText animated className="h-4 w-1/2" />
                    <div className="flex justify-between items-center">
                      <IonSkeletonText animated className="h-5 w-16" />
                      <IonSkeletonText animated className="h-8 w-8 rounded-full" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center m-2.5">
              {wishlistProducts?.length === 0 ? (
                <div className="flex flex-col justify-center items-center gap-3">
                  <IonIcon className="text-[6rem] text-center text-gray-800" icon={heart} />
                  <div className="text-[1.20rem]">{t("Your wish List is empty")}</div>
                  <button className="py-3 px-[3.5rem] bg-primary rounded-2xl" onClick={handleGoToSearchPage}>
                    {t("Explore")}
                  </button>
                </div>
              ) : (
                <div className="flex flex-col gap-3 ">
                  <div className="flex flex-col gap-2">
                    <div className="grid grid-cols-2  justify-center gap-y-2.5 gap-x-2.5 ">
                      {wishlistProducts?.map((product) => {
                        return (
                          <NewListViewProduct
                            type="newList"
                            key={product.id}
                            product={product}
                            className="w-full h-full"
                            lazyload={false}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </MaxWidthContainer>
      </Page.Content>
    </Page>
  );
};

export default Wishlist;
